(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('protocol-group', {
                parent: 'entity',
                url: '/protocol-group',
                data: {
                    authorities: [],
                    pageTitle: 'ProtocolGroups'
                },
                ncyBreadcrumb: {
                    label: 'ProtocolGroup'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/protocol-group/list/protocol-group.html',
                        controller: 'ProtocolGroupController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_PROTOCOL_GROUP];
                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_PROTOCOL_GROUP, access);
                }]
            });
    }
})();
